import React from 'react';
import { Box, Grid, Typography, Paper, Tabs, Tab } from '@mui/material';
import SummaryCards from './SummaryCards.tsx';
import OverviewCharts from './OverviewCharts.tsx';
import SourcePieChart from './SourcePieChart.tsx';
import StatusPieChart from './StatusPieChart.tsx';
import CampaignROIChart from './CampaignROIChart.tsx';
import ConversionFunnel from './ConversionFunnel.tsx';
import RevenueTrendChart from './RevenueTrendChart.tsx';
import RegionalPerformanceChart from './RegionalPerformanceChart.tsx';

const LeadAnalyticsDashboard = () => {
  const [activeTab, setActiveTab] = React.useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 1 }}>
        📈 Lead Analytics Dashboard
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 3 }}>
        Comprehensive insights into your lead generation performance
      </Typography>

      <SummaryCards />

      <Paper sx={{ mt: 3, p: 1 }}>
        <Tabs value={activeTab} onChange={handleTabChange} centered>
          <Tab label="Overview" />
          <Tab label="Sources" />
          <Tab label="Status" />
          <Tab label="Conversion" />
          <Tab label="Revenue" />
          <Tab label="Regional" />
        </Tabs>
      </Paper>

      <Box sx={{ mt: 2 }}>
        {activeTab === 0 && <OverviewCharts />}
        {activeTab === 1 && <SourcePieChart />}
        {activeTab === 2 && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}><StatusPieChart /></Grid>
            <Grid item xs={12} md={6}><ConversionFunnel /></Grid>
          </Grid>
        )}
        {activeTab === 3 && <ConversionFunnel showAnalysis />}
        {activeTab === 4 && <RevenueTrendChart />}
        {activeTab === 5 && <RegionalPerformanceChart />}
      </Box>
    </Box>
  );
};

export default LeadAnalyticsDashboard;
